module.exports = __webpack_public_path__ + "static/media/100-search-file.02d99abe.svg";